import React from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';

import useInView from '../../utils/hooks/useInView';

const YoutubeIframe = ({
  title,
  width,
  height,
  videoId,
  autoplay,
  controls,
  mute,
  ...props
}) => {
  const [ref, isIframeVisible] = useInView();

  const src = `https://www.youtube.com/embed/${videoId}?autoplay=${+autoplay}&controls=${+controls}&playlist=${videoId}&loop=1&rel=0&modestbranding=1&showinfo=0&mute=${+mute}`;

  return (
    <Box ref={ref} {...props} data-youtube-iframe>
      {isIframeVisible && (
        <iframe title={title} width={width} height={height} frameBorder="0" src={src} />
      )}
    </Box>
  );
};

YoutubeIframe.defaultProps = {
  autoplay: false,
  controls: false,
  mute: false,
  height: '100%',
  width: '100%',
};

YoutubeIframe.propTypes = {
  autoplay: PropTypes.bool,
  controls: PropTypes.bool,
  height: PropTypes.string,
  mute: PropTypes.bool,
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  width: PropTypes.string,
};

export default YoutubeIframe;
